<div class="search-bar full-width">
  <input class="full-width" type="text" readonly [title]="valueToView || ''"
    [ngClass]="{'pointer': !disabled && !!settings}"
    [placeholder]="!!settings.placeholder && !disabled ? settings.placeholder : ''" [(ngModel)]="valueToView"
    [disabled]="disabled || !settings" (mouseenter)="inputOnHover = true" (mouseleave)="inputOnHover = false"
    (click)="onClickInput($event)" />
  @if(!disabled){
  <i class="fa fa-caret-down" [ngClass]="{'disabled': disabled}"></i>
  }

  @if(showOptions && settings){
  <div class="options-container" [ngClass]="{'bottom': bottomHalf}">
    <bt-loader [loaderId]="loaderId">
      @if(settings.showSearch){
      <input class="full-width" type="text" placeholder="Search..." [(ngModel)]="searchText"
        (ngModelChange)="onFilterChange()" (click)="$event.stopPropagation()" />
      }
      @if(datasourceCopy?.length){
      <div class="overflow-container">
        @for(item of datasourceCopy; track item; let i = $index){
        <div class="pointer hover flex center" inViewport (inViewportAction)="inViewportAction($event, item)"
          (click)="$event.stopPropagation()">
          <input type="checkbox" class="margin-left-small" [(ngModel)]="item.isMultiChecked"
            (ngModelChange)="onChangeCheck(item)">
          <div class="padding-small flex-1 max-width" (click)="onSelect($event, item)">
            <ng-content *ngTemplateOutlet="currentTemplate; context:{ $implicit: item, index:i }"></ng-content>
          </div>
        </div>
        }
      </div>
      }
      @if(datasourceCopy && !datasourceCopy.length){
      <div class="padding align-center" (click)="showOptions = false">
        There are no data
      </div>
      }
    </bt-loader>
  </div>
  }
</div>

<ng-template #defaultItemTemplate let-item let-index>
  {{settings.stringsDs ? item : item[settings.textProperty]}}
</ng-template>